module.exports = __webpack_public_path__ + "static/media/logo-blue.577167e9.svg";